import { render, staticRenderFns } from "./AnnualCheckup.vue?vue&type=template&id=1b6237ca&scoped=true"
import script from "./AnnualCheckup.vue?vue&type=script&lang=js"
export * from "./AnnualCheckup.vue?vue&type=script&lang=js"
import style0 from "./AnnualCheckup.vue?vue&type=style&index=0&id=1b6237ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6237ca",
  null
  
)

export default component.exports